<template>
    <div :style="!isActiveCard ? activeStyle :  { background: '#1E1E1E'}" :class="size"
        class="rounded-lg pt-1 content-between grid grid-cols-4"
        >
         <div class="col-span-4 flex flex-row justify-between relative">
            <div class="rounded-r-full font-bold text-sm text-left text-white mt-4 px-3 py-1 max-w-max h-7 z-10 absolute"
                :class="getStatus(card.status, card.request_status).class">
                <span class="text-xs"> {{ getStatus(card.status, card.request_status).message }} </span>
                <em v-if="card.status === 'locked' || card.status === 'active' || card.status === 'canceled'"
                :class="getStatus(card.status, card.request_status).icon"
                class="px-1"></em>
            </div>

            <div class="text-right pl-40 ml-2 z-0">
                <img alt="Logo"
                    class="mt-2 mr-4 filter grayscale opacity-60"
                    :src="$page.props.white_label.data.logo_black"
                    width="400"
                />
            </div>

            <div v-if="card.is_virtual"
                style="background: rgba(135, 15, 229, 0.9)"
                :class="!isActiveCard ? 'absolute top-4' : ''"
                class="flex items-center rounded-2xl px-4 py-1 max-w-max h-7 z-10 absolute top-4 right-0 mb-10 mr-4">
                <span class="text-center text-sm text-white">Virtual</span>
            </div>
        </div>
        <div
            :class="{'-mt-4': !isActiveCard}"
            class="text-left text-yellow-300 text-lg mt-2 px-8 py-4 flex flex-col col-span-3"
        >
            <div class="font-bold flex flex-row items-center space-x-2">
                <span class="text-sm font-bold">
                    {{ activeCardVirtualCardNumber }}
                </span>
            </div>
            <div class="flex items-center space-x-5">
                <div class="flex flex-col text-white">
                    <div class="text-xs">Validade</div>
                    <div class="text-base font-bold">
                        {{ formatExpirationDate(card.expiration_date) }}
                    </div>
                </div>
                <div class="flex flex-col text-white mt-1">
                    <div class="text-xs">CVC</div>
                    <div class="text-base font-bold">
                    {{ showCvv ? activeCardVirtualCardCvv || "***" : "***" }}
                    </div>
                </div>
                <div @click="showCvv = !showCvv"
                    style="background: #3B3B3B"
                    class="rounded-full text-white text-xs cursor-pointer text-left h-6 w-6 flex items-center justify-center -mt-2"
                >
                    <em class="fas" :class="{ 'fa-eye': !showCvv, 'fa-eye-slash': showCvv }" />
                </div>
            </div>

            <div class="text-xs font-bold whitespace-nowrap">
                {{ card.embossing_name }}
            </div>
        </div>
        <div class="text-right px-3 col-span-1 pb-5 flex flex-col justify-between">
            <div class=" flex justify-end mt-4" :class="{'-mt-1': !isActiveCard}">
                <div  @click="copyNumber"
                class="flex items-center justify-center bg-yellow-300 text-xs rounded-full w-8 h-8  cursor-pointer mr-5">
                    <i class="text-black font-bold far fa-copy"/>
                </div>
            </div>
            <div>
                <img
                    alt="Logo"
                    class="mx-auto"
                    src="images/Mastercard.png"
                    width="50"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        card: {
            type: Object,
            default: () => ({})
        },
        size: {
            type: String,
            default: 'w-96 h-56'
        },
        isActiveCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showNumber: false,
            showCvv: false,
            activeCardVirtualCardNumber: "**** **** **** ****",
            activeCardVirtualCardCvv: null,
            virtualCard: {
                is_virtual: true,
                expiration_date: '----',
                embossing_name: '----',
                card_number: '****************',
                card_number_true: null
            },
            activeStyle: {
                background: '#1E1E1E',
                opacity: 0.10000000149011612
            },
        }
    },
    created() {
        this.getNumber();
        this.getSecurityCode();
    },
    methods: {
        formatExpirationDate(date) {
            return date ? date.substr(0, 2) + "/" + date.substr(2, 2) : '**/**';
        },
        formatCardNumber(number) {
            number = number.toString();
            return (
                number.substr(0, 4) +
                " " +
                number.substr(4, 4) +
                " " +
                number.substr(8, 4) +
                " " +
                number.substr(12, 4)
            );
        },
         async getNumber() {
            const { data } = await axios.get("/card-virtual-card-data", {
                params: {
                    value_type: "card_number",
                    card_uuid: this.card.reference_card_uuid,
                    last_4_digits: this.card.last_4_digits
                }
            })
            this.activeCardVirtualCardNumber = this.formatCardNumber(String(data.card_number)) ?? "**** **** **** ****"

        },
        async getSecurityCode(){
            const { data } = await axios.get('/card-virtual-card-data', { params: {
                value_type: 'security_code',
                card_uuid: this.card.reference_card_uuid,
                last_4_digits: this.card.last_4_digits
            }})
            this.activeCardVirtualCardCvv = data.security_code ?? '---'
        },
        copyNumber() {
            let number = this.activeCardVirtualCardNumber
            if ("clipboard" in navigator) {
                navigator.clipboard.writeText(number).then(() => {
                    this.$toast.open({
                    message: "Número do cartão copiado com sucesso.",
                    type: "success",
                    duration: 3000,
                    position: "top",
                    showCloseButtonOnHover: true
                });
                })
            }
        },
         getStatus(status, request_status) {
            if (request_status === "rejected") {
                return {
                    message: "Solicitação recusada",
                    class: "bg-red-500"
                };
            }
            switch (status) {
                case "active":
                    return {
                        message: "Ativo",
                        class: "bg-green-500",
                        icon: "ml-2 fas fa-check"
                    };
                case "locked":
                    return {
                        message: "Bloqueado",
                        class: "bg-gray-500",
                        icon: "fas fa-lock"
                    };
                case "canceled":
                    return {
                        message: "Cancelado",
                        class: "bg-red-500",
                        icon: "fas fa-times"
                    };
                case null:
                    return {
                        message: "Nenhum cartão localizado",
                        class: "bg-gray-500"
                    };
                default:
                    return {};
            }
        }
    },
}
</script>
